import IsMobileMixin from "@sellers-shield-home-protection/ss-ui-kit/src/mixins/IsMobileMixin";
import UserMixin from "@mixins/UserMixin";
import CommonHeader from "@sellers-shield-home-protection/ss-ui-kit/src/components/Common/CommonHeader/CommonHeader";
import CommonFooter from '@components/layout/CommonFooter/CommonFooter';
import CommonSidebar from "@sellers-shield-home-protection/ss-ui-kit/src/components/Common/CommonSidebar/CommonSidebar";
import {mapActions, mapState} from 'pinia';
import {useAuthStore, useLayoutStore} from '@store';

export default {
    mixins: [
        IsMobileMixin,
        UserMixin
    ],
    components: {
        CommonHeader,
        CommonSidebar,
        CommonFooter,
    },
    data: () => ({
        logo: {
            path: require('@assets/images/ss-logo-white-bg.png'),
        },
        itemsBottom: [
            {
                icon: 'fa-life-ring',
                label: 'Support',
                popover: 'Help',
                action: 'help',
            },
            {
                icon: 'fa-user-circle',
                label: 'My Profile',
                popover: 'My Profile',
                action: 'profile',
            },
        ],
    }),
    computed: {
        ...mapState(useLayoutStore, {
            headerBreadcrumbs: 'headerBreadcrumbs',
        }),
        navItems() {
            const dashboard = {
                icon: 'fa-shield',
                label: 'My Disclosures',
                popover: 'My Disclosures',
                action: 'dashboard',
                childrenActions: [
                    'order-details',
                ],
            };

            return [
                dashboard
            ];
        },
        navItemsBottom() {
            return this.itemsBottom;
        },
        navItemActive() {
            const routeName = this.$route.name || 'dashboard',
                navItems = [...this.navItems, ...this.navItemsBottom];

            return navItems.filter(navItem => {
                return navItem.action === routeName ||
                    (navItem.childrenActions || []).find(childAction => childAction === routeName);
            });
        },
        hideMobileBackButton() {
            return this.$route.name === 'dashboard';
        },
    },
    methods: {
        ...mapActions(useAuthStore, {
            logout: 'logout',
        }),
        handleGoBack() {
            this.$router.push({name: 'dashboard'});
        },
        handleBreadcrumbItemClick(item) {
            this.$router.push(item.to);
        },
        async handleNavItemClick(item) {
            if (item.action === 'sign-out') {
                await this.$router.push({name: 'logout'});
            } else if (this.$route.name === item.action) {
                this.$router.go(0);
            } else {
                await this.$router.push({name: item.action});
            }
        },
    },
}